import React from "react";
import Richtext from "@dip/helsecore/src/components/shared/Wrappers/Richtext";

import type { TextElementProps } from "./type.d";

export default function TextElement({ title, text }: TextElementProps) {
  return (
    <div className="[&>*:first-child]:pt-0 [&>*:last-child]:pb-0">
      { title && <h1>{title}</h1> }
      { text && <Richtext className="enonicText" text={text} /> }
    </div>
  );
}
